import { call, METHODS } from '../http-client';

const ROUTE_PREFIX = 'disputes';

export const getDisputes = async (params) => {
    return call(METHODS.GET, ROUTE_PREFIX, null, { params });
};

export const getDispute = async (orderId) => {
    return call(METHODS.GET, ROUTE_PREFIX, orderId);
};
